import React from 'react';
import {AgGridColumn} from '../../components/agGridColumn';
import Grid from '../../components/grid';
import {ActionProps} from '../../components/gridAction';
import {booleanFormater} from "../../components/gridUtils";

const dataHoraFormater = (params: any) => {
    if (!params.value) {
        return '';
    }
    const [data, hora] = String(params.value).split(' ');
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano} ${hora || ''}`.trim();
};

const FluxoList = () => {
    const actions: Array<ActionProps> = [
        {
            route: 'fluxos/incluir',
            color: 'success',
            type: 'normal',
            title: 'Incluir'
        },
        {
            route: 'fluxos/alterar',
            color: 'warning',
            type: 'grid',
            title: 'Alterar'
        },
        {
            route: 'fluxos/visualizar',
            color: 'info',
            type: 'grid',
            title: 'Visualizar',
        },
        {
            // Abre o editor com a copia: codigo e nome sao ajustados antes de salvar.
            route: 'fluxos/duplicar',
            color: 'primary',
            type: 'grid',
            title: 'Duplicar',
        },
        {
            // Fluxo nao se exclui: inativo some da abertura de processos.
            route: 'fluxo/toggle_status',
            color: 'secondary',
            type: 'post',
            title: 'Ativar/Inativar',
            callBackFunction: () => true,
        },
    ];

    return (
        <Grid actions={actions} rota="fluxo/list">
            <AgGridColumn width={90} sort="asc" headerName="#" checkboxSelection field="id" sortable={true} filter={'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn width={130} headerName="Código" field="codigo" sortable={true} filter={true}></AgGridColumn>
            <AgGridColumn flex={2} minWidth={220} headerName="Nome" field="nome" sortable={true} filter={true}></AgGridColumn>
            <AgGridColumn width={100} headerName="Etapas" field="etapas" sortable={false}></AgGridColumn>
            <AgGridColumn width={100} headerName="Itens" field="itens" sortable={false}></AgGridColumn>
            <AgGridColumn width={100} headerName="Versão" field="versao" sortable={true} filter={'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn width={100} headerName="Ativo" field="ativo" sortable={true} valueFormatter={booleanFormater}></AgGridColumn>
            <AgGridColumn width={160} headerName="Alterado em" field="dataAlteracao" sortable={true} valueFormatter={dataHoraFormater}></AgGridColumn>
        </Grid>
    );
};

export default FluxoList;
